import type { Page } from '@efdigital/ll-addon-data';
import { findPageWithContent } from '@efdigital/ll-admin-v2/data/builders/content/pages.ts';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Store } from '@warp-drive/core';

import type { ProgramsProgramCohortContentModuleModel } from '../module.ts';

export type ParamsPageId = {
  page_id: string;
};

export type ProgramsProgramCohortContentModulePageModel =
  ProgramsProgramCohortContentModuleModel &
    ParamsPageId & {
      page: Page;
    };

export default class ProgramsProgramCohortContentModulePageRoute extends Route<ProgramsProgramCohortContentModulePageModel> {
  @service declare store: Store;

  async model(params: ParamsPageId) {
    const page = await this.store.request(findPageWithContent(params.page_id));
    return {
      ...(this.modelFor(
        'programs.program.cohort.content.module'
      ) as ProgramsProgramCohortContentModuleModel),
      ...params,
      page: page.content.data,
    };
  }
}
